import { Injectable, Signal, computed, inject } from '@angular/core';
import { IConfigDictionary } from '@partners/api';
import { ShellStore } from '@partners/state';
import { TConfigPartition, TLink } from '@partners/types';
import { PolicyService } from '../../process';
import { IConfigFacade } from '../model';

@Injectable({
  providedIn: 'root'
})
export abstract class ConfigFacade implements IConfigFacade {
  protected readonly _policyService = inject(PolicyService);
  protected readonly _shellStore = inject(ShellStore);

  abstract readonly configDictionary$$: Signal<IConfigDictionary>;

  text$$ = computed<TConfigPartition<string>>(() => this.configDictionary$$()?.text);
  indication$$ = computed<TConfigPartition<boolean>>(() => this.configDictionary$$()?.indication);
  params$$ = computed<TConfigPartition<object>>(() => this.configDictionary$$()?.params);
  links$$ = computed<TConfigPartition<TLink>>(() => this.configDictionary$$()?.links);

  constructor() {}

  fromText$$(key: string): Signal<string> {
    return computed(() => {
      const text: TConfigPartition<string> = this.text$$();
      return this.fromConfig<string>(text, key);
    });
  }

  fromIndication$$(key: string): Signal<boolean> {
    return computed(() => {
      const ind: TConfigPartition<boolean> = this.indication$$();
      return this.fromConfig<boolean>(ind, key);
    });
  }

  fromParams$$(key: string): Signal<object> {
    return computed(() => {
      const params: TConfigPartition<object> = this.params$$();
      return this.fromConfig<object>(params, key);
    });
  }

  fromLinks$$(key: string): Signal<TLink> {
    return computed(() => {
      const links: TConfigPartition<TLink> = this.links$$();
      return this.fromConfig<TLink>(links, key);
    });
  }

  private fromConfig<T>(dictionary: TConfigPartition<unknown>, key: string): T {
    if (dictionary && key in dictionary) {
      return dictionary[key] as T;
    }
    return null;
  }
}
